import { EssityColumnProps } from '@components/shared/paginatedEssityTable/GridHelper';
import formatHelpers from '@helper/formatHelpers';
import * as DocumentSourceMapper from '@services/mappers/DocumentSource';
import { DocumentSource, SourceDocumentDto } from '@services/src/models';

export const ImportedDocumentsTableColumns: EssityColumnProps<SourceDocumentDto>[] = [
	{
		dataIndex: 'id',
		key: 'id',
		title: 'Id',
	},
	{
		dataIndex: 'name',
		key: 'name',
		title: 'Name',
		filter: 'contains',
	},
	{
		dataIndex: 'source',
		key: 'source',
		title: 'Category',
		filter: 'enum',
		filterDictionary: DocumentSource,
		enumMapper: DocumentSourceMapper,
		render: (value: DocumentSource) => DocumentSourceMapper.map(value),
	},
	{
		dataIndex: 'createdDate',
		key: 'createdDate',
		title: 'Date',
		filter: 'dateRange',
		render: (value?: Date) =>
			formatHelpers.formatDate(value, 'DD.MM.YYYY, HH:mm:ss'),
	},
	{
		dataIndex: 'createdByUserId',
		key: 'createdByUserId',
		title: 'User ID',
	},
];
